import SpecialtyName from '../../core/doctor/domain/SpecialtyName';

export function isSpecialtyAnesthesiologist(specialty: SpecialtyName) {
  return [SpecialtyName.ANESTHESIOLOGIST, SpecialtyName.ANESTHESIOLOGIST_INTENSIVIST].includes(specialty);
}

export function isSpecialtySurgeon(specialty: SpecialtyName) {
  return [SpecialtyName.GENERAL_SURGEON, SpecialtyName.ORTHOPEDIC_SURGEON].includes(specialty);
}
